import { storeDataSchema } from './store-data-schema';
import type { ValidationErrorsMap } from './validation-error-types';
import { zodIssuesToValidationErrors } from './zod-to-validation-errors';

function getStoreId(item: unknown, index: number): string {
  const details = (item as { details?: { uiId?: string } })?.details;
  return (
    (typeof details?.uiId === 'string' && details.uiId) || `store-${index}`
  );
}

export function validatePointsOfSales(
  value: unknown,
  shouldSkipEmpty = true
): ValidationErrorsMap {
  if (!Array.isArray(value) || value.length === 0) {
    if (shouldSkipEmpty) {
      return {};
    }

    return {
      general: [{ message: 'Empty point of sales', path: [] }],
    };
  }

  const errors: ValidationErrorsMap = {};

  for (let i = 0; i < value.length; i++) {
    const result = storeDataSchema.safeParse(value[i]);
    if (!result.success) {
      const id = getStoreId(value[i], i);
      errors[id] = zodIssuesToValidationErrors(result.error.issues);
    }
  }

  return errors;
}
